module.exports = __webpack_public_path__ + "assets/img/5.8e6a0e76.jpg";